import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const PieChartOrders = ({ delivered = 60, pending = 25, expired = 15, loading = false, roleId = 1 }) => {
  const navigate = useNavigate();

  const total = delivered + pending + expired;
  let deliveredPercent = 0;
  let pendingPercent = 0;
  let expiredPercent = 0;

  if (total > 0) {
    deliveredPercent = Math.round((delivered / total) * 100);
    pendingPercent = Math.round((pending / total) * 100);
    expiredPercent = 100 - deliveredPercent - pendingPercent;
  }

  const data = [
    { name: 'Entregados', value: delivered, color: '#769B40', percent: deliveredPercent },
    { name: 'Pendientes', value: pending, color: '#FFC000', percent: pendingPercent },
    { name: 'Vencidos', value: expired, color: '#BD002A', percent: expiredPercent }
  ];

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 1;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    // fondo 
    const textWidth = 46; // ancho
    const textHeight = 46; // Altura 
    return (
      <g style={{ userSelect: 'none' }}>
        {/* Fondo redondeado */}
        <rect
          x={x - textWidth / 2}
          y={y - textHeight / 2}
          width={textWidth}
          height={textHeight}
          rx={100} // Radio para esquinas redondeadas
          fill="#00000040" // Negro con 25% de opacidad
          style={{ pointerEvents: 'none' }}
        />
        {/* Texto */}
        <text
          x={x}
          y={y}
          fill="white"
          textAnchor="middle"
          dominantBaseline="central"
          style={{
            fontSize: '12px',
            fontWeight: 'bold',
            pointerEvents: 'none',
            fontFamily: 'ITC-bold'
          }}
        >
          {`${data[index].percent}%`}
        </text>
      </g>
    );
  };

  if (loading) {
    return (
      <div className="w-full h-[250px] flex items-center justify-center bg-white rounded-[10px] shadow-md">
        <div className="w-6 h-6 border-2 border-gray-300 rounded-full animate-spin border-t-transparent" />
        <p className="ml-3 text-gray-500">Cargando...</p>
      </div>
    );
  }

  return (
    <div
      className="flex flex-col justify-between gap-3 w-full h-full p-4 bg-white rounded-[10px] shadow-lg">
      <h2 className="text-lg text-center text-blue font-itcbold">Cantidad de pedidos de Materiales</h2>
      <div className="relative " style={{ height: '220px' }}>
        <ResponsiveContainer width="100%" height="100%">
          {total > 0 ? (
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius="40%"
                outerRadius="85%"
                paddingAngle={0}
                dataKey="value"
                labelLine={false}
                label={renderCustomizedLabel}
                activeShape={null}
                activeIndex={null}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color}
                    style={{
                      outline: 'none',
                      ':focus': {
                        outline: 'none'
                      },
                      ':active': {
                        outline: 'none'
                      }
                    }} />
                ))}
              </Pie>
            </PieChart>
          ) : (
            <div className="flex items-center justify-center h-full">
              <div className="text-center text-gray-400">
                <p className="text-lg font-semibold">No hay datos disponibles</p>
              </div>
            </div>
          )}
        </ResponsiveContainer>
      </div>
      <div className="flex flex-col justify-center gap-3 ">
        {data.map((item, index) => (
          <div key={`legend-${index}`} className="flex items-center justify-between">
            <div className='flex items-center'>
              <div
                className="w-3 h-3 mr-2 rounded-full"
                style={{ backgroundColor: item.color }}
              />
              <span className="text-xs font-itcmedium text-[#111928]">{item.name}</span>
            </div>
            <p className='font-itcbold text-[#404040] text-[12px]'>{item.percent}%</p>
          </div>
        ))}
      </div>
      <div className='flex justify-center'>
        <button
          onClick={() => {
            navigate(`/${roleId == 1 ? 'oc' : 'mis-oc'}`);
            requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
          }}
          className='text-white font-itcmedium w-[80%] bg-green rounded-[5px] p-[10px]'>
          Ver todos
        </button>
      </div>
    </div>
  );
};

export default PieChartOrders;